import React from "react";
import { Link,useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';

const Landing = () => {
    const navigate = useNavigate();
    return (
        <section>
            <Helmet>
                <title>Evaluationz: Ecommerce</title>
                {(window.location.pathname === '/ecommerce') &&
                    <script src="//evaluationz.mykampaign.com/focus/7.js" type="text/javascript" charset="utf-8"
                            async="async"></script>
                }
                <meta name="description" content="See how Evaluationz brings security to eCommerce through verification" />
                <meta name="keywords" content="address verification, criminal verification, drug panel testing, employment verification, education verification, employee verification, user verification, vendor verification, Identity check, Social Media Check, Reference check, Drug test, Digital verification, passport verification, credit check, API Integration, Reduced TAT, Real time verification, verification Specialist, NASCOM empanelled, credit score check, Evaluationz, Evaluationz India Pvt. Ltd., Verification India, AI, Artificial Intelligence, BlueG, Coporate verification, IT Verification, Ites Verification, Banking and Financial Services Industry Verification, Automative verification, eCommerce verification, healthcare verification, rental verificaion, matrimonial verification, hyperlocal verification, blue collar verification, white collar verification"/>
                <meta property="og:description" content="See how Evaluationz brings security to eCommerce through verification" />
                <meta property="og:url" content="https://www.evaluationz.com/ecommerce" />
                <meta property="og:image" content="https://www.evaluationz.com/images/favicon.jpg" />
                <meta property="og:image:secure_url" content="https://www.evaluationz.com/images/favicon.jpg" />
                <meta name="twitter:image" content="https://www.evaluationz.com/images/favicon.jpg" />
            </Helmet>

            <div className="about-section bg-black py-4 mt-5">
                <div className="container pt-5">
                    <div className="row align-items-center">
                        <div className="col-lg-6 pb-30">
                            <div className="about-section-item about-item-image text-md-left text-center">
                                <img src="images/industries/ecommerce/image-1.png"
                                     alt="shape"
                                     className="red-image-left shadow-2xl"/>
                            </div>
                        </div>

                        <div className="col-lg-6 pb-30">
                            <div className="about-section-item about-item-details">
                                <div className="section-title section-title-left text-start">
                                    <h1 className="c-red font-weight-bolder">Screening when every individual is your customer touchpoint</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-section bg-white py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="about-section-item about-item-details">
                                <div className="section-title section-title-left text-start">
                                    <p className="text-black">As the gig and partnership economies become more popular, it is the third party vendor or associate who is the one interacting
                                        with end customers on a day-to-day basis. Therefore, the verification of drivers, delivery partners and other staff is crucial. From
                                        background screening to employment and qualification records to criminal records, all form part of the exhaustive verification
                                        process from Evaluationz.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h3 className="c-blue">
                        Recommended Verifications
                    </h3>
                    <div className="row align-items-center mt-4">
                        <div className="col-md-4 d-flex align-items-center justify-content-start">
                            <img src="images/industries/ecommerce/icon-1.png" alt="shape" width="80"/>
                            <span className="text-black ml-2">
                                Digital Identity Verification
                            </span>
                        </div>

                        <div className="col-md-4 d-flex align-items-center justify-content-start">
                            <img src="images/industries/ecommerce/icon-2.png" alt="shape" width="80"/>
                            <span className="text-black ml-2">
                                Digital Address Verification
                            </span>
                        </div>

                        {/* <div className="col-md-4 d-flex align-items-center justify-content-start">
                            <img src="images/industries/ecommerce/icon-3.png" alt="shape" width="80"/>
                            <span className="text-white ml-2">
                                Education Verification
                            </span>
                        </div> */}
                        <div className="col-md-4 d-flex align-items-center justify-content-start">
                            <img src="images/industries/ecommerce/icon-4.png" alt="shape" width="80"/>
                            <span className="text-black ml-2">
                               Driving Licence Verification
                            </span>
                        </div>
                    </div>

                    <div className="row align-items-center mt-4">
                        <div className="col-md-4 d-flex align-items-center justify-content-start">
                            <img src="images/industries/ecommerce/icon-6.png" alt="shape" width="80"/>
                            <span className="text-black ml-2">
                                Drug Tests
                            </span>
                        </div>
                        <div className="col-md-4 d-flex align-items-center justify-content-start">
                            <img src="images/industries/ecommerce/icon-5.png" alt="shape" width="80"/>
                            <span className="text-black ml-2">
                                Legal Verification
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-section bg-black py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12 pb-30">
                            <div className="about-section-item about-item-details">
                                <div className="section-title section-title-left text-start">
                                    <h2 className="c-red">The Evaluationz Edge</h2>
                                </div>
                                <div className="about-content">
                                    <p className="text-white">Our comprehensive verifications process builds on Evaluationz’ proprietary BlueG platform that uses artificial intelligence, and
                                        componentized government identity documents and databases.</p>

                                    <p className="text-white">
                                        Evaluationz verifications is made incredibly convenient and quick with seamless API integration with existing ATS and HRIS
                                        systems. The HR department gets easy interactions that feel like the native application that they are used to while the process
                                        is intuitive and transparent for the potential candidate.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row align-items-center mt-4">
                        <div className="col-md-3 d-flex align-items-center justify-content-start">
                            <img src="images/industries/ecommerce/icon-7.png" alt="shape" width="80"/>
                            <span className="text-white ml-2">
                                Seamless API Integration
                            </span>
                        </div>

                        <div className="col-md-3 d-flex align-items-center justify-content-start">
                            <img src="images/industries/ecommerce/icon-8.png" alt="shape" width="80"/>
                            <span className="text-white ml-2">
                               Intuitive And Hassle-free Process
                            </span>
                        </div>

                        <div className="col-md-3 d-flex align-items-center justify-content-start">
                            <img src="images/industries/ecommerce/icon-9.png" alt="shape" width="80"/>
                            <span className="text-white ml-2">
                                Multiple Payment Options
                            </span>
                        </div>

                        <div className="col-md-3 d-flex align-items-center justify-content-start">
                            <img src="images/industries/ecommerce/icon-10.png" alt="shape" width="80"/>
                            <span className="text-white ml-2">
                                Automatically Trigger Initial And Repeat Verifications
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-section bg-white py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 py-2 cursor-pointer" onClick={() => navigate(`/dont-let-your-delivery-agents-damage-your-brand`)}>
                            {/*onClick={() => history.push(`/dont-let-your-delivery-agents-damage-your-brand`)}>*/}
                            <div className="user-card h-100 blog-card bg-white">
                                <div className="about-section-item about-item-image text-center blue-image-left">
                                    <img src="images/blogs/blog-8/blog-8.png" alt="blog" />
                                </div>
                                <div className="card-body">
                                    <h4>Don't let your in-house or 3rd party delivery agents damage your brand. Safeguard your reputation with verification</h4>
                                    <p className="mb-0">A company’s most valuable asset is its reputation. As an e-commerce platform, the truth is that your reputation is dependent on multiple </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 py-2 cursor-pointer" onClick={() => navigate(`/blog5`)}>
                            {/*onClick={() => history.push(`/blog5`)}>*/}
                            <div className="user-card h-100 blog-card bg-white">
                                <div className="about-section-item about-item-image text-center blue-image-left">
                                    <img src="images/blogs/blog-5/blog-5.jpg" alt="blog" />
                                </div>
                                <div className="card-body">
                                    <h4>Why digital user verifications are vital to your ecommerce business</h4>
                                    <p className="mb-0">2020: Delivery agent scams Amazon off Rs. 27,000. 2021: Amazon duped off Rs. 20 lakhs in phone return fraud. These are just a few cases of many</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-section bg-white pb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <Link to="/technology"
                                  target="_blank"
                                  className="btn btn-primary btn-white shadow-lg">
                                For more details on the BlueG platform and API integration, go here
                            </Link>
                        </div>

                        <div className="col-12 mt-4">
                            <Link to="/services"
                                  target="_blank"
                                  className="btn btn-primary btn-white shadow-lg">
                                For more information on our Services, go here
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Landing;
